function countryDelimiterCharacter(currency) {
  switch (currency) {
    case 'DKK':
      return '.';
    case 'GBP':
      return ',';
    default:
      return ' ';
  }
}

const shouldRoundDecimalPrice = (currency) => {
  return currency === 'SEK' || currency === 'DKK';
};

const roundWithTwoDecimals = (value) => {
  return Math.round(value * 100) / 100;
};

export const addDelimiterToInteger = (n, delimiter = ' ') => {
  // Adds whitespace for better readability
  // e.g.: 1234000 -> 1 234 000
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
};

export const formatPrice = (value, currency) => {
  if (value < 1) {
    return shouldRoundDecimalPrice(currency)
      ? '1'
      : roundWithTwoDecimals(value);
  } else {
    return shouldRoundDecimalPrice(currency)
      ? addDelimiterToInteger(
          Math.round(value),
          countryDelimiterCharacter(currency)
        )
      : addDelimiterToInteger(
          roundWithTwoDecimals(value),
          countryDelimiterCharacter(currency)
        );
  }
};
